import { LineChart } from "@mantine/charts"
import { Card, Group, Text } from "@mantine/core"
import { IconChartLine } from "@tabler/icons-react"
import _ from "lodash"

import { getConsistentChartColor } from "@costory/shared/utils/consistentColors"
import { formatNumber } from "@costory/shared/utils/format"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { usePreviewMetricsDatasourceQuery } from "@costory/front/queries/metricsDatasources"

export const PreviewMetric = ({
  selectedDatasource,
}: {
  selectedDatasource: string | undefined
}) => {
  const previewQuery = usePreviewMetricsDatasourceQuery(selectedDatasource)

  return (
    <>
      <Text fw={100} c="dimmed">
        Preview of the usage metric (top dimensions)
      </Text>
      {selectedDatasource ? (
        <div style={{ height: 300 }}>
          <QueryWrapper query={previewQuery}>
            {({ data: previewData }) => {
              const data = _(previewData.metrics)
                .groupBy((el) => el.date)
                .map((series) => {
                  return {
                    date: series[0].date,
                    ...Object.assign(
                      {},
                      ...series.map((ee) => ({
                        [ee.name]: ee.value,
                      })),
                    ),
                  }
                })
                .value()
              const series = _.uniq(
                previewData.metrics.map((el) => el.name),
              ).map((name, index) => ({
                name,
                color: getConsistentChartColor(index),
              }))
              return (
                <LineChart
                  data={_.sortBy(data, (a) => a.date)}
                  h={300}
                  dataKey="date"
                  series={series}
                  tickLine="y"
                  connectNulls={false}
                  yAxisProps={{
                    allowDataOverflow: true,
                    tickFormatter: (value) =>
                      formatNumber({
                        value,
                        numberType: "decimal",
                        maxDigit: 3,
                      }),
                  }}
                />
              )
            }}
          </QueryWrapper>
        </div>
      ) : (
        <Card h={300} withBorder>
          <Text ta="center" c="dimmed" mt="xl">
            Preview usage metric
          </Text>
          <Group justify="center">
            <IconChartLine size={48} />
          </Group>
        </Card>
      )}
    </>
  )
}
